import { NgModule } from '@angular/core';
import { HtmlSanitizerPipe } from './html-sanitizer.pipe';
import { ShortNamePipe } from './short-name.pipe';
import { FindByKeyPipe } from './find-by-key.pipe';
import { FilterPipe } from './filter.pipe';
import { FilterActivePipe } from './filter-active.pipe';
import { SplitPipe } from './split.pipe';
import { CurrencySymbolPipe } from './currency-symbol.pipe';
import { DateStringPipe } from './date-string.pipe';
import { TimeAgoPipe } from './time-ago.pipe';
import { DictionaryPipe } from './dictionary.pipe';
import { OrderByStatusPipe } from './orderByStatus.pipe';

@NgModule({
  exports: [
    ShortNamePipe,
    HtmlSanitizerPipe,
    FilterPipe,
    FilterActivePipe,
    FindByKeyPipe,
    SplitPipe,
    CurrencySymbolPipe,
    DateStringPipe,
    TimeAgoPipe,
    DictionaryPipe,
    OrderByStatusPipe
  ],
  declarations: [
    ShortNamePipe,
    HtmlSanitizerPipe,
    FilterPipe,
    FilterActivePipe,
    FindByKeyPipe,
    SplitPipe,
    CurrencySymbolPipe,
    DateStringPipe,
    TimeAgoPipe,
    DictionaryPipe,
    OrderByStatusPipe
  ],
})
// TODO: Make pipes standalone
export class PipesModule { }
